import { useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import { InlineSpinner } from "components/base/Spinner";
import { useModals } from "ModalProvider";
import { FETCH_PROJECT_IDEAS } from "./graphql";
import ProjectIdeaForm from "./ProjectIdeaForm";

const IdeasView = () => {
  const { loading, error, data } = useQuery(FETCH_PROJECT_IDEAS);
  const modal = useModals();

  const ideas = data?.projectIdeas;

  function editHandler() {
    modal.present({
      title: "Edit Project Ideas",
      children: <ProjectIdeaForm originalIdea={ideas} onSaved={modal.hide} />,
    });
  }

  return (
    <div className="card">
      <div className="flex justify-between items-center">
        <h5>Ideas</h5>
        {!loading && <Button onClick={editHandler}>Edit</Button>}
      </div>
      <div className="mt-2">
        {loading && <InlineSpinner size={21} />}
        {error && <Errors error={error} />}
        {ideas ? (
          <div className=" whitespace-pre-wrap">{ideas.content}</div>
        ) : (
          <div className="text-gray-500">
            No ideas yet. Add some to get started!
          </div>
        )}
      </div>
    </div>
  );
};

export default IdeasView;
